import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-female-yoga': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-yoga&exp=web_pricing_for_desktop~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_pricing_for_desktop/activity-female-yoga'
					),
			},
		},
		'activity-male-chair-workouts': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-chair-workouts&exp=web_pricing_for_desktop~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_pricing_for_desktop/activity-male-chair-workouts'
					),
			},
		},
		female: {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female&exp=web_pricing_for_desktop~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_pricing_for_desktop/female'
					),
			},
		},
	},
]

export default config
